export const Mutation = {
    CREATE_ACTIVE_MACHINE                   : 'CREATE_ACTIVE_MACHINE',
    UPDATE_ACTIVE_MACHINE                   : 'UPDATE_ACTIVE_MACHINE',
    DELETE_ACTIVE_MACHINE                   : 'DELETE_ACTIVE_MACHINE',
    CREATE_PRODUCTION_LINE_COLLAPSE_STATE   : 'CREATE_PRODUCTION_LINE_COLLAPSE_STATE',
    CHANGE_COLLAPSABLE_PRODUCTION_LINE_STATE        : 'CHANGE_COLLAPSABLE_PRODUCTION_LINE_STATE'
}
